import { shouldSessionStorageEncryptFactory } from '@my-backoffice/app/shared/factories/should-session-storage-encrypt.factory';
import { SHOULD_SESSION_STORAGE_ENCRYPT } from '@my-backoffice/app/shared/tokens/should-session-storage-encrypt.token';
import { WINDOW } from '@my-backoffice/app/shared/tokens/window.token';
import { FactoryProvider } from '@angular/core';

export const SHOULD_SESSION_STORAGE_ENCRYPT_PROVIDER: FactoryProvider = {
  deps: [WINDOW],
  provide: SHOULD_SESSION_STORAGE_ENCRYPT,
  useFactory: shouldSessionStorageEncryptFactory,
};
